import { AccountPlan } from 'hooks/use-account-plans.hook';

interface SanitizedUtilityAccountData {
  text: string;
  value: number;
  utilityId: number;
  state: string;
  stateId: number;
  zipCode: string;
  medicaidCardRequiresThirdPartyVerification: boolean;
}

export const fetchSanitizedUtilityAccounts = (
  plans: AccountPlan[]
): SanitizedUtilityAccountData[] => {
  return plans
    .filter(plan => !plan?.utilityAccounts[0]?.gasOnly)
    .map(plan => {
      const utilityAccount = plan?.utilityAccounts[0];
      return {
        text: `${utilityAccount?.utility?.displayName} #${String(
          utilityAccount?.accountNumber
        )} (${utilityAccount?.displayServiceAddress})`,
        value: utilityAccount?.id,
        utilityId: utilityAccount?.utility?.id,
        state: utilityAccount?.utility?.state?.abbreviation,
        stateId: utilityAccount?.utility?.state?.id,
        zipCode: utilityAccount?.serviceAddressZip || '',
        medicaidCardRequiresThirdPartyVerification:
          utilityAccount?.utility?.state
            ?.medicaidCardRequiresThirdPartyVerification || false,
      };
    });
};
